import { render, staticRenderFns } from "./ReportQuestionariCompilati.vue?vue&type=template&id=4fff3f47&"
import script from "./ReportQuestionariCompilati.vue?vue&type=script&lang=js&"
export * from "./ReportQuestionariCompilati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports